import { createFileRoute } from "@tanstack/react-router";
import WhatIsCargoNova from "@/pages/WhatIsCargoNova";
import { pageHead } from "@/lib/seo";
import { whatIsCargoNovaBreadcrumb } from "@/utils/schema";

export const Route = createFileRoute("/what-is-cargonova")({
  head: () => ({
    ...pageHead("/what-is-cargonova", "en"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(whatIsCargoNovaBreadcrumb("en")),
      },
    ],
  }),
  component: WhatIsCargoNova,
});
